import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function Usegetspecificpayrollheaderdata(payrollId) {
  //   console.log(payrollId, employeeId);
  return useQuery(
    ['employee-payroll-data1', payrollId],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_PAYROLL_API, {
          payroll_id: payrollId,
        })
      );

      return response.data;
    },
    {
      enabled: !!payrollId,
    }
  );
}
